class Copy {
    constructor() { }

    initCopy() {
        document.querySelectorAll('[data-copy]').forEach(el => {
            if (el._copyBound) return;
            el._copyBound = true;

            el.addEventListener('click', () => {
                const text = el.dataset.copyText || el.dataset.copy;
                if (!text) return;

                this.copy(text).then(() => {
                    const position = el.dataset.tooltipPosition || 'top';
                    this.tooltip(el, 'Copiado', 3000, position);
                });
            });
        });
    }

    async copy(text) {
        try {
            await navigator.clipboard.writeText(text);
        } catch {
            const t = document.createElement('textarea');
            t.value = text;
            t.style.position = 'fixed';
            t.style.left = '-9999px';
            document.body.appendChild(t);
            t.select();
            document.execCommand('copy');
            t.remove();
        }
    }

    tooltip(el, msg = 'Copiado', duration = 3000, position = 'top') {
        if (el._tooltip) el._tooltip.remove();
        if (el._tooltipTimeout) clearTimeout(el._tooltipTimeout);

        const computedPosition = window.getComputedStyle(el).position;
        if (computedPosition === 'static') {
            el.style.position = 'relative';
        }

        const tip = document.createElement('div');
        tip.textContent = msg;

        tip.style.cssText = `
            position: absolute;
            z-index: 10;
            padding: 6px 10px;
            border-radius: 12px;
            background: #000;
            color: #fff;
            font-size: 12px;
            white-space: nowrap;
            opacity: 0;
            pointer-events: none;
            transition: opacity .15s ease, transform .15s ease;
        `;

        const baseTransform = 'translate(-50%, -50%)';

        switch (position) {
            case 'right':
                tip.style.left = '100%';
                tip.style.top = '50%';
                tip.style.transform = 'translate(8px, -50%)';
                break;

            case 'left':
                tip.style.right = '100%';
                tip.style.top = '50%';
                tip.style.transform = 'translate(-8px, -50%)';
                break;

            case 'bottom':
                tip.style.left = '50%';
                tip.style.top = '100%';
                tip.style.transform = 'translate(-50%, 8px)';
                break;

            case 'top':
            default:
                tip.style.left = '50%';
                tip.style.bottom = '100%';
                tip.style.transform = 'translate(-50%, -8px)';
        }

        el.appendChild(tip);

        tip.offsetHeight;
        tip.style.opacity = '1';

        switch (position) {
            case 'right':
                tip.style.transform = 'translate(12px, -50%)';
                break;
            case 'left':
                tip.style.transform = 'translate(-12px, -50%)';
                break;
            case 'bottom':
                tip.style.transform = 'translate(-50%, 12px)';
                break;
            case 'top':
            default:
                tip.style.transform = 'translate(-50%, -12px)';
        }

        el._tooltip = tip;
        el._tooltipTimeout = setTimeout(() => {
            tip.style.opacity = '0';

            switch (position) {
                case 'right':
                    tip.style.transform = 'translate(4px, -50%)';
                    break;
                case 'left':
                    tip.style.transform = 'translate(-4px, -50%)';
                    break;
                case 'bottom':
                    tip.style.transform = 'translate(-50%, 4px)';
                    break;
                case 'top':
                default:
                    tip.style.transform = 'translate(-50%, -4px)';
            }

            setTimeout(() => {
                tip.remove();
                el._tooltip = null;
                el._tooltipTimeout = null;
            }, 200);
        }, duration);
    }
}

export default new Copy();
